(function () {
  'use strict';

  function isVisible(el) {
    if (!el || el.tagName !== 'IMG') return false;
    var rect = el.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0.01;
  }

  function forceLoad(img) {
    if (!img || img.dataset.tcbLazyForced === '1') return;
    if (img.complete && img.naturalWidth > 0) return;

    img.dataset.tcbLazyForced = '1';
    img.loading = 'eager';

    var src = img.currentSrc || img.src || img.getAttribute('data-src');
    if (!src) return;

    img.src = src;
    if (img.srcset) {
      var srcset = img.srcset;
      img.removeAttribute('srcset');
      img.srcset = srcset;
    }

    if (typeof img.decode === 'function') {
      img.decode().catch(function () {});
    }
  }

  function scanVisible(root) {
    (root || document).querySelectorAll('img').forEach(function (img) {
      if (!isVisible(img)) return;
      if (img.complete && img.naturalWidth > 0) return;
      forceLoad(img);
    });
  }

  function observeLazyImages() {
    if (!('IntersectionObserver' in window)) {
      scanVisible();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) forceLoad(entry.target);
        });
      },
      { rootMargin: '240px 0px', threshold: 0.01 }
    );

    document.querySelectorAll('img[loading="lazy"], img[data-src]').forEach(function (img) {
      if (img.dataset.tcbLazyObs === '1') return;
      img.dataset.tcbLazyObs = '1';
      observer.observe(img);
    });
  }

  function boot() {
    observeLazyImages();
    scanVisible();
    window.addEventListener(
      'scroll',
      function () {
        scanVisible();
      },
      { passive: true }
    );
    window.addEventListener('load', function () {
      observeLazyImages();
      scanVisible();
      window.setTimeout(scanVisible, 400);
      window.setTimeout(scanVisible, 1500);
      window.setTimeout(scanVisible, 3500);
      window.setTimeout(scanVisible, 6000);
    });

    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        observeLazyImages();
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
